export default "__VITE_ASSET__b$LvkkC0__"